import React, {useEffect, useState} from "react";
import './InstalledEquipmentReview.css'
import {useGetExistingReview} from "../../hooks/Technician/useGetExistingReview";
import {Bounce, toast} from "react-toastify";
import {saveInstalledEquipmentReview} from "../../services/Technician/equipmentReviewService";

interface InstalledEquipmentReviewProps {
    equipment: string;
    ticketUniqueCode: string;
    onBack: () => void;
    setLoadingAnimation: (visible: boolean) => void;
    changeLoadingMessage: (change: boolean) => void;
    ticketState: string;
}

const InstalledEquipmentReview: React.FC<InstalledEquipmentReviewProps> = ({
                                                                               equipment,
                                                                               onBack,
                                                                               ticketUniqueCode,
                                                                               setLoadingAnimation,
                                                                               changeLoadingMessage,
                                                                               ticketState
                                                                           }) => {

    const [initialAdditive, setInitialAdditive] = useState("");
    const [initialPressure, setInitialPressure] = useState("");
    const [initialFactor, setInitialFactor] = useState("");
    const [firstInitialObjective, setFirstInitialObjective] = useState("");
    const [firstInitialRealValue, setFirstInitialRealValue] = useState("");
    const [secondInitialObjective, setSecondInitialObjective] = useState("");
    const [secondInitialRealValue, setSecondInitialRealValue] = useState("");

    const [finalAdditive, setFinalAdditive] = useState("");
    const [finalPressure, setFinalPressure] = useState("");
    const [finalFactor, setFinalFactor] = useState("");
    const [firstFinalObjective, setFirstFinalObjective] = useState("");
    const [firstFinalRealValue, setFirstFinalRealValue] = useState("");
    const [secondFinalObjective, setSecondFinalObjective] = useState("");
    const [secondFinalRealValue, setSecondFinalRealValue] = useState("");
    const [thirdFinalObjective, setThirdFinalObjective] = useState("");
    const [thirdFinalRealValue, setThirdFinalRealValue] = useState("");
    const [fourthFinalObjective, setFourthFinalObjective] = useState("");
    const [fourthFinalRealValue, setFourthFinalRealValue] = useState("");
    const [fifthFinalObjective, setFifthFinalObjective] = useState("");
    const [fifthFinalRealValue, setFifthFinalRealValue] = useState("");

    const {review, additive} = useGetExistingReview(ticketUniqueCode, equipment);

    useEffect(() => {
        if (review && additive) {
            setInitialAdditive(additive);
            setInitialPressure(review.initialPressure || "");
            setInitialFactor(review.initialFactor || "");
            setFirstInitialObjective(review.firstInitialObjective || "");
            setFirstInitialRealValue(review.firstInitialRealValue || "");
            setSecondInitialObjective(review.secondInitialObjective || "");
            setSecondInitialRealValue(review.secondInitialRealValue || "");

            setFinalAdditive(additive);
            setFinalPressure(review.finalPressure || "");
            setFinalFactor(review.finalFactor || "");
            setFirstFinalObjective(review.firstFinalObjective || "");
            setFirstFinalRealValue(review.firstFinalRealValue || "");
            setSecondFinalObjective(review.secondFinalObjective || "");
            setSecondFinalRealValue(review.secondFinalRealValue || "");
            setThirdFinalObjective(review.thirdFinalObjective || "");
            setThirdFinalRealValue(review.thirdFinalRealValue || "");
            setFourthFinalObjective(review.fourthFinalObjective || "");
            setFourthFinalRealValue(review.fourthFinalRealValue || "");
            setFifthFinalObjective(review.fifthFinalObjective || "");
            setFifthFinalRealValue(review.fifthFinalRealValue || "");
        }
    }, [review, additive]);

    const saveReview = () => {

        const validateNumber = (value: string) => !isNaN(Number(value));

        if (
            !validateNumber(initialPressure) ||
            !validateNumber(initialFactor) ||
            !validateNumber(firstInitialRealValue) ||
            !validateNumber(secondInitialRealValue) ||
            !validateNumber(finalPressure) ||
            !validateNumber(finalFactor) ||
            !validateNumber(firstFinalRealValue) ||
            !validateNumber(secondFinalRealValue) ||
            !validateNumber(thirdFinalRealValue) ||
            !validateNumber(fourthFinalRealValue) ||
            !validateNumber(fifthFinalRealValue)
        ) {
            toast.error("Todos los valores de presión, factor, objetivo y real deben ser números", {
                position: 'top-right',
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                theme: 'colored',
                transition: Bounce,
            });
            return;
        }

        const updatedReview = {
            equipmentAdditive: initialAdditive,
            installedEquipmentReviewValues: {
                initialAdditive,
                initialPressure,
                initialFactor,
                firstInitialObjective,
                firstInitialRealValue,
                secondInitialObjective,
                secondInitialRealValue,
                finalAdditive,
                finalPressure,
                finalFactor,
                firstFinalObjective,
                firstFinalRealValue,
                secondFinalObjective,
                secondFinalRealValue,
                thirdFinalObjective,
                thirdFinalRealValue,
                fourthFinalObjective,
                fourthFinalRealValue,
                fifthFinalObjective,
                fifthFinalRealValue
            }
        };

        changeLoadingMessage(false);
        setLoadingAnimation(true);

        saveInstalledEquipmentReview(ticketUniqueCode, equipment, updatedReview)
            .then((response) => {
                toast.success('¡Guardado correctamente!', {
                    position: 'top-right',
                    autoClose: 4000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false,
                    theme: 'colored',
                    transition: Bounce,
                });
            })
            .catch((e: any) => {
                toast.error("Errro al guardar los datos..", {
                    position: 'top-right',
                    autoClose: 4000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false,
                    theme: 'colored',
                    transition: Bounce,
                });
            })
            .finally(() => setTimeout(() => setLoadingAnimation(false), 600));
    };


    return (
        <div>
            <div className="clients-info-view-header">
                <button onClick={onBack}>REGRESAR</button>
                <div className="clients-info-view-header-title">
                    <p>{equipment}</p>
                </div>
                {["ASSIGNED", "IN_PROGRESS"].includes(ticketState) && (
                    <span className="material-icons-outlined icon-unselected" onClick={saveReview}>
                    save
                </span>
                )}

            </div>
            <div className="layout-container">
                <div className="title">Antes</div>

                <div className="row full">
                    <span className="label">ADITIVO:</span>
                    <input
                        className="input"
                        type="text"
                        value={initialAdditive}
                        disabled={true}
                        onChange={(e) => setInitialAdditive(e.target.value)}
                    />
                </div>

                <div className="row half">
                    <span className="label">PRESIÓN</span>
                    <input
                        className="input"
                        type="text"
                        value={initialPressure}
                        onChange={(e) => setInitialPressure(e.target.value)}
                    />
                </div>

                <div className="row half">
                    <span className="label">FACTOR</span>
                    <input
                        className="input"
                        type="text"
                        value={initialFactor}
                        onChange={(e) => setInitialFactor(e.target.value)}
                    />
                </div>

                <div className="row half">
                    <span className="label">OBJETIVO</span>
                    <input
                        className="input"
                        type="text"
                        value={firstInitialObjective}
                        onChange={(e) => setFirstInitialObjective(e.target.value)}
                    />
                    <input
                        className="input"
                        type="text"
                        value={secondInitialObjective}
                        onChange={(e) => setSecondInitialObjective(e.target.value)}
                    />
                </div>
                <div className="row half">
                    <span className="label">REAL</span>
                    <input
                        className="input"
                        type="text"
                        value={firstInitialRealValue}
                        onChange={(e) => setFirstInitialRealValue(e.target.value)}
                    />
                    <input
                        className="input"
                        type="text"
                        value={secondInitialRealValue}
                        onChange={(e) => setSecondInitialRealValue(e.target.value)}
                    />
                </div>
            </div>
            <div className="layout-container">
                <div className="title">Después</div>

                <div className="row full">
                    <span className="label">ADITIVO:</span>
                    <input
                        className="input"
                        type="text"
                        value={finalAdditive}
                        disabled={true}
                        onChange={(e) => setFinalAdditive(e.target.value)}
                    />
                </div>

                <div className="row half">
                    <span className="label">PRESIÓN</span>
                    <input
                        className="input"
                        type="text"
                        value={finalPressure}
                        onChange={(e) => setFinalPressure(e.target.value)}
                    />
                </div>

                <div className="row half">
                    <span className="label">FACTOR</span>
                    <input
                        className="input"
                        type="text"
                        value={finalFactor}
                        onChange={(e) => setFinalFactor(e.target.value)}
                    />
                </div>

                <div className="row half">
                    <span className="label">OBJETIVO</span>
                    <input
                        className="input"
                        type="text"
                        value={firstFinalObjective}
                        onChange={(e) => setFirstFinalObjective(e.target.value)}
                    />
                    <input
                        className="input"
                        type="text"
                        value={secondFinalObjective}
                        onChange={(e) => setSecondFinalObjective(e.target.value)}
                    />
                    <input
                        className="input"
                        type="text"
                        value={thirdFinalObjective}
                        onChange={(e) => setThirdFinalObjective(e.target.value)}
                    />
                    <input
                        className="input"
                        type="text"
                        value={fourthFinalObjective}
                        onChange={(e) => setFourthFinalObjective(e.target.value)}
                    />
                    <input
                        className="input"
                        type="text"
                        value={fifthFinalObjective}
                        onChange={(e) => setFifthFinalObjective(e.target.value)}
                    />
                </div>
                <div className="row half">
                    <span className="label">REAL</span>
                    <input
                        className="input"
                        type="text"
                        value={firstFinalRealValue}
                        onChange={(e) => setFirstFinalRealValue(e.target.value)}
                    />
                    <input
                        className="input"
                        type="text"
                        value={secondFinalRealValue}
                        onChange={(e) => setSecondFinalRealValue(e.target.value)}
                    />
                    <input
                        className="input"
                        type="text"
                        value={thirdFinalRealValue}
                        onChange={(e) => setThirdFinalRealValue(e.target.value)}
                    />
                    <input
                        className="input"
                        type="text"
                        value={fourthFinalRealValue}
                        onChange={(e) => setFourthFinalRealValue(e.target.value)}
                    />
                    <input
                        className="input"
                        type="text"
                        value={fifthFinalRealValue}
                        onChange={(e) => setFifthFinalRealValue(e.target.value)}
                    />
                </div>
            </div>
        </div>
    );
}

export default InstalledEquipmentReview;
